var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.test)}}),_c('div',{staticClass:"flex-centered"},[_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v("Angel's blockchain gallery")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }